// extracted by mini-css-extract-plugin
export default {"container":"chip_container__rVSBD","text":"chip_text__BF5NX","clossing_tag":"chip_clossing_tag__hLSeN"};